import { AppError } from "../errors/index.js";
/**
 * **مهامُّ العنصر — قواعدُها في موضعٍ واحد.**
 *
 * «اللي هيعمل الريل حد واللي هيعمل الكفر حد تاني، وكل واحد مسؤول عن مهمته،
 * والتأخير أو التقدّم على مهمته مش على العنصر كله» (شادي). فلكلّ مهمةٍ صاحبٌ
 * وموعدٌ وحالٌ ومراجعة — **وحالُ العنصر يُشتقّ منها ولا يُحرَّك باليد**.
 */
export const PLAN_TASK_STATES = [
    "not_started",
    "in_progress",
    "delivered",
    "approved",
    "returned",
];
export const PLAN_TASK_STATE_LABEL = {
    not_started: "plans.task.state.not_started",
    in_progress: "plans.task.state.in_progress",
    delivered: "plans.task.state.delivered",
    approved: "plans.task.state.approved",
    returned: "plans.task.state.returned",
};
// ═══════════════════════ الأولوية ═══════════════════════
/**
 * **الأولوية — للعنصر وللكارت معاً، بأربع درجات.**
 *
 * وترتيبُها هنا ترتيبُ الفرز: العاجلُ أوّلاً. ولا يُعاد تعريفُها في شاشة.
 */
export const PRIORITIES = ["urgent", "high", "normal", "low"];
export const PRIORITY_LABEL = {
    urgent: "priority.urgent",
    high: "priority.high",
    normal: "priority.normal",
    low: "priority.low",
};
export function isPriority(value) {
    return typeof value === "string" && PRIORITIES.includes(value);
}
const MOVES = {
    start: { from: ["not_started", "returned"], to: "in_progress" },
    deliver: { from: ["not_started", "in_progress", "returned"], to: "delivered" },
    approve: { from: ["delivered"], to: "approved" },
    return: { from: ["delivered"], to: "returned" },
};
/** إلى أين تذهب المهمة بهذه الحركة — **أو يُرفَض بكوده ويُسمّى الحالان** */
export function moveTask(from, move) {
    const rule = MOVES[move];
    if (!rule.from.includes(from)) {
        throw new AppError("PLAN_TASK_MOVE_INVALID", { context: { from } });
    }
    return rule.to;
}
/**
 * **بوابةُ التسليم — معاينةٌ للعميل، أو لا تسليم.**
 *
 * وكانت بوابةً على العنصر كلّه («معاينة» و«غلاف»)، فصارت على كلّ مهمة: **فمعاينةُ
 * مهمة الكفر هي الغلاف**، ولا يُسلِّم أحدٌ شغلاً لا يُرى.
 */
export function assertDeliverable(at) {
    if (at.hasPreview)
        return;
    throw new AppError("PLAN_ITEM_INCOMPLETE", {
        fields: [{ field: "preview", messageKey: "plans.missing.preview" }],
    });
}
// ═══════════════════════ حالُ العنصر من مهامّه ═══════════════════════
/** ما بعد العميل — لا تشتقّه المهامّ: النشرُ وقرارُ العميل والإلغاء يملكونه */
const PAST_INTERNAL = [
    "client_approved",
    "scheduled",
    "published",
    "done",
    "cancelled",
];
/**
 * **حالُ العنصر الداخليّ يُحسَب من مهامّه — لا يُحرَّك باليد.**
 *
 *  - كلُّها معتمَدة ⇐ معتمَدٌ داخلياً (فيراه العميل)
 *  - كلُّها مسلَّمةٌ أو معتمَدة ⇐ في المراجعة
 *  - فيها مرجَّعة ⇐ مرجَّعٌ للتعديل
 *  - فيها ما بدأ ⇐ شغّال
 *  - وإلّا ⇐ مسنَد (ومسودّةٌ بلا مهامّ)
 *
 * **وما بعد العميل لا يُمسّ**: معتمَدٌ من العميل أو مجدولٌ أو منشور يبقى كما هو.
 */
export function deriveItemState(current, tasks) {
    if (PAST_INTERNAL.includes(current))
        return current;
    if (tasks.length === 0)
        return "draft";
    if (tasks.every((t) => t === "approved"))
        return "approved_internally";
    if (tasks.every((t) => t === "delivered" || t === "approved"))
        return "internal_review";
    if (tasks.some((t) => t === "returned"))
        return "internal_revision";
    if (tasks.some((t) => t !== "not_started"))
        return "in_progress";
    return "assigned";
}
// ═══════════════════════ موعدُ المهمة ═══════════════════════
/**
 * **موعدُ المهمة لا يتعدّى تسليمَ العنصر** — يُرفَض على حقله، لا في القاعدة.
 *
 * فمهمةٌ موعدُها بعد تسليم العنصر تَعِدُ بما لا يمكن: العنصرُ لا يُسلَّم قبلها.
 */
export function assertTaskDue(dueAt, deliverBy, field = "dueAt") {
    if (dueAt.getTime() <= deliverBy.getTime())
        return;
    throw new AppError("VALIDATION_FAILED", {
        fields: [{ field, messageKey: "plans.task.dueAfterItem" }],
    });
}
//# sourceMappingURL=tasks.js.map